import CustomerSettings from "./company/customer";
import JobSettings from "./company/job";
import TaskSettings from "./company/task";
import TaskChecklistSettings from "./company/taskChecklist";
import InvoicingSettings from "./company/invoicing";
import OpportunitySettings from "./company/opportunity";
import QuotingSettings from "./company/quoting";
import BankingSettings from "./company/banking";
import PurchasesSettings from "./company/purchases";
import TimeEntrySettings from "./company/timeEntry";
import DebtChasingSettings from "./company/debtChasing";
import StaffSettings from "./company/staff";
import CommunicationsSettings from "./company/communications";
// Change #100326 - WhatsApp numbers, templates, quick replies, notifications and consent.
import WhatsAppSettings from "./company/whatsapp";
import MenuSettings from "./company/menus";
import CardList from "./company/cardList/cardList";
import GeneralSettings from "./company/general";
import { UserInvitation } from "./company/userInvitation";
import CompanyInvitations from "./userProfile/companyInvitations";
import TeamMembers from "./company/teamMembers";
import Users from "./company/users";
import Debug from "./userProfile/debug";
import ManageLicense from "./company/manageLicense";
import Subscriptions from "./company/subscriptions";
import SuperScribeSettings from "./SuperAmin/scribe";
import SuperGeneralSettings from "./SuperAmin/general";
import CompanySettingsIntro from "./company/intro";
import Billing from "./userProfile/billing";
import LiabilitySettings from "./company/liability";
import ProfileSettingsIntro from "./userProfile/intro";
import SuperAdminSettingsIntro from "./SuperAmin/intro";
import CompanySecuritySettings from "./company/security";
import UserRoles from "./company/security/userRoles";
import BillingOverview from "./Billing/BillingOverview";
import WalletBilling from "./Billing/Wallet";
import InvoiceRecipients from "./Billing/InvoiceRecipients";
import BillingSettingsIntro from "./Billing/intro";
import CompanySettings from "./company/company";
import MyShortcutSettings from "./userProfile/myShortcuts";
import EmailSettings from "./company/email";
import AppointmentSettings from "./company/appointment";
import UserProfileGeneralSettings from "./userProfile/general";
// Task 24711 - forms, listed where the rest of the configuration lives.
import FormsSettings from "./company/forms";
import AccountingPeriods from "./company/AccountingPeriods";
import EventsSettings from "./company/events";
import VehicleSettings from "./company/Vehicle";

import ThirdPartyIntegrationSettings from "./company/thirdPartyIntegration";
import ProformaInvoicingSettings from "./company/ProformaInvoice";

import StaffLeaveSettingsPage from "./company/staffLeave";

import OrganisationDepartmentSettings from "./company/OrganisationDepartment";
import SlaSettings from "./company/sla";
import CompanySiteLocations from "./company/siteLocation";
import ClockInKiosksSettings from "./company/clockInKiosks";
import CompanySims from "./company/sims";
import ProductSettings from "./company/ProductSettings";
import SalesOrderSettings from "./company/SalesOrder";
import MasterPaymentProvider from "./SuperAmin/MasterPaymentProvider";
import MasterExternalIdentificationProvider from "./SuperAmin/MasterExternalIdentificationProvider";
import PurchaseOrderSettings from "./company/purchaseOrder";
import ManageUserPassword from "./userProfile/manageUserPassword";
import ClockInPinSettings from "./userProfile/clockInPin";
import RecentlyViewedSettings from "./userProfile/recentlyViewed";
import MyDevicesSettings from "./userProfile/devices";
import NotificationCenter from "./SuperAmin/NotificationCenter";
import CronSchedules from "./SuperAmin/CronSchedules";
import SocialMediaManagementSettings from "./company/SocialMediaManagement";
import LeadsSettings from "./company/Leads";
import ModulesSettingsIntro from "./Modules/intro";
import AllModulesSettings from "./Modules/AllModules";
import CallsSettings from "./company/Calls/CallsSetings";
import LoyaltySettingsPage from "./company/Loyalty";
import PortalProfiles from "./company/PortalProfiles";
import SuperMenuSettings from "./SuperAmin/SuperMenu";
// Task 24886 - menus defined in ZCRM_Master and rolled out to every company.
import GlobalMenuSettings from "./SuperAmin/GlobalMenus";
import Master from "./SuperAmin/Master";
import MasterThirdPartyPricing from "./SuperAmin/MasterThirdPartyPricing";
import MasterSim from "./SuperAmin/MasterSim";
import SystemServers from "./SuperAmin/SystemServers";
import SystemDeviceSettings from "./company/SystemDevice";
import SystemDeviceHardwareSettings from "./company/SystemDeviceHardware";
import SMSSettings from "./company/sms";
import AssetSettings from "./company/asset";
import AttachmentSettings from "./company/attachment";
import CompanyVehicleSettings from "./company/CompanyVehicle";
import ConfigItems from "./company/ConfigItems";
import ApiKeysSettings from "./company/apiKeys";
import ESignReminderSchedules from "./company/esignReminderSchedule";
import MasterConfigItem from "./SuperAmin/MasterConfigItem";
import SuperAdminDevices from "./SuperAmin/Devices";
import DatabaseDelta from "./SuperAmin/DatabaseDelta";
import ServerErrorLog from "./SuperAmin/ServerErrorLog";
import AuthFailureLog from "./SuperAmin/AuthFailureLog";
import SystemChanges from "./SuperAmin/SystemChanges";
import UserCompanyMapping from "./SuperAmin/UserCompanyMapping";
import Developers from "./SuperAmin/Developers";
import CompanyOnboarding from "./company/onboarding";



// ===== BEGIN Task 24429 master admin (generated by ztools/masteradmin) ===== imports
import AccessBlockReason from "./SuperAmin/AccessBlockReason";
import ApiKeyToAuthCapability from "./SuperAmin/ApiKeyToAuthCapability";
import AttachmentProvider from "./SuperAmin/AttachmentProvider";
import BankAccountProvider from "./SuperAmin/BankAccountProvider";
import CallRecording from "./SuperAmin/CallRecording";
import CompaniesHouseSicCodeGroup from "./SuperAmin/CompaniesHouseSicCodeGroup";
import CompaniesHouseSicCodeGroupValue from "./SuperAmin/CompaniesHouseSicCodeGroupValue";
import CompanyStatus from "./SuperAmin/CompanyStatus";
import CompanyToUserInvitation from "./SuperAmin/CompanyToUserInvitation";
import CompanyToUserInvitationStatus from "./SuperAmin/CompanyToUserInvitationStatus";
import CompanyToUserRequest from "./SuperAmin/CompanyToUserRequest";
import CompanyUsageStats from "./SuperAmin/CompanyUsageStats";
import CompanyUsageStatsHistory from "./SuperAmin/CompanyUsageStatsHistory";
import CronInterval from "./SuperAmin/CronInterval";
import DashboardBox from "./SuperAmin/DashboardBox";
import DocumentationGuide from "./SuperAmin/DocumentationGuide";
import GlobalApiLog from "./SuperAmin/GlobalApiLog";
import GlobalEcommerceStore from "./SuperAmin/GlobalEcommerceStore";
import GlobalEmailAccount from "./SuperAmin/GlobalEmailAccount";
import GlobalEmailOutbound from "./SuperAmin/GlobalEmailOutbound";
import GlobalExternalIdMapping from "./SuperAmin/GlobalExternalIdMapping";
import GlobalFoodTableWidget from "./SuperAmin/GlobalFoodTableWidget";
import GlobalLoyaltyPortal from "./SuperAmin/GlobalLoyaltyPortal";
import GlobalProductSelfServeWidget from "./SuperAmin/GlobalProductSelfServeWidget";
import MasterBankAccountFeedProvider from "./SuperAmin/MasterBankAccountFeedProvider";
import MasterBankAccountFeedStatus from "./SuperAmin/MasterBankAccountFeedStatus";
import MasterBankAccountProvider from "./SuperAmin/MasterBankAccountProvider";
import MasterBankAccountThirdPartyDataProvider from "./SuperAmin/MasterBankAccountThirdPartyDataProvider";
import MasterConfigItemFieldType from "./SuperAmin/MasterConfigItemFieldType";
import MasterDashboardTemplate from "./SuperAmin/MasterDashboardTemplate";
import MasterDatabaseTemplate from "./SuperAmin/MasterDatabaseTemplate";
import MasterDatabaseUtilisationAlert from "./SuperAmin/MasterDatabaseUtilisationAlert";
import MasterEmailAccountInbound from "./SuperAmin/MasterEmailAccountInbound";
import MasterEmailOutbound from "./SuperAmin/MasterEmailOutbound";
import MasterEmailTemplate from "./SuperAmin/MasterEmailTemplate";
import MasterEmailTemplateSystemType from "./SuperAmin/MasterEmailTemplateSystemType";
import MasterHardwareCatalogType from "./SuperAmin/MasterHardwareCatalogType";
import MasterHardwareItem from "./SuperAmin/MasterHardwareItem";
import MasterHardwareItemConnectivity from "./SuperAmin/MasterHardwareItemConnectivity";
import MasterHmrcEmploymentAllowance from "./SuperAmin/MasterHmrcEmploymentAllowance";
import MasterMeetingBotIndex from "./SuperAmin/MasterMeetingBotIndex";
import MasterNfcTag from "./SuperAmin/MasterNfcTag";
import MasterObjectType from "./SuperAmin/MasterObjectType";
import MasterPdfThemeOutput from "./SuperAmin/MasterPdfThemeOutput";
import MasterPostCodeLookup from "./SuperAmin/MasterPostCodeLookup";
import MasterProspectCompany from "./SuperAmin/MasterProspectCompany";
import MasterProspectCompanySicCode from "./SuperAmin/MasterProspectCompanySicCode";
import MasterReferralPartner from "./SuperAmin/MasterReferralPartner";
import MasterReferralPartnerCommission from "./SuperAmin/MasterReferralPartnerCommission";
import MasterReportingGroup from "./SuperAmin/MasterReportingGroup";
import MasterReportingItem from "./SuperAmin/MasterReportingItem";
import MasterSecurityAuthCapability from "./SuperAmin/MasterSecurityAuthCapability";
import MasterSecurityAuthCapabilityFrontEndLocations from "./SuperAmin/MasterSecurityAuthCapabilityFrontEndLocations";
import MasterSecurityAuthCapabilityToPortal from "./SuperAmin/MasterSecurityAuthCapabilityToPortal";
import MasterSecurityAuthGroup from "./SuperAmin/MasterSecurityAuthGroup";
import MasterSecurityAuthRole from "./SuperAmin/MasterSecurityAuthRole";
import MasterSimAssignment from "./SuperAmin/MasterSimAssignment";
import MasterSlowQuerySnapshot from "./SuperAmin/MasterSlowQuerySnapshot";
import MasterSlowQueryTopOffender from "./SuperAmin/MasterSlowQueryTopOffender";
import MasterSpecialDay from "./SuperAmin/MasterSpecialDay";
import MasterStaff from "./SuperAmin/MasterStaff";
import MasterSubscription from "./SuperAmin/MasterSubscription";
import MasterSystemDebugLog from "./SuperAmin/MasterSystemDebugLog";
import MasterSystemEmailTemplate from "./SuperAmin/MasterSystemEmailTemplate";
import MasterSystemErrorLog from "./SuperAmin/MasterSystemErrorLog";
import MasterSystemField from "./SuperAmin/MasterSystemField";
import MasterSystemModule from "./SuperAmin/MasterSystemModule";
import MasterSystemWalletServiceRate from "./SuperAmin/MasterSystemWalletServiceRate";
import MasterSystemWalletStatus from "./SuperAmin/MasterSystemWalletStatus";
import MasterSystemWalletTopUpAttempt from "./SuperAmin/MasterSystemWalletTopUpAttempt";
import MasterThirdPartyPricingBracket from "./SuperAmin/MasterThirdPartyPricingBracket";
import MasterThirdPartyPricingService from "./SuperAmin/MasterThirdPartyPricingService";
import MasterTimeFrameInterval from "./SuperAmin/MasterTimeFrameInterval";
import MasterTokenKey from "./SuperAmin/MasterTokenKey";
import MasterTokenKeyAccess from "./SuperAmin/MasterTokenKeyAccess";
import MasterTokenKeyType from "./SuperAmin/MasterTokenKeyType";
import MasterUserToSecurityAuthPermission from "./SuperAmin/MasterUserToSecurityAuthPermission";
import MasterWifiPortalSite from "./SuperAmin/MasterWifiPortalSite";
import PermissionOption from "./SuperAmin/PermissionOption";
import ReferralIncome from "./SuperAmin/ReferralIncome";
import ReferralIncomeItem from "./SuperAmin/ReferralIncomeItem";
import ReferralPayout from "./SuperAmin/ReferralPayout";
import ReferralRecognitionItem from "./SuperAmin/ReferralRecognitionItem";
import ReferralReward from "./SuperAmin/ReferralReward";
import SubscriptionCancellationReason from "./SuperAmin/SubscriptionCancellationReason";
import SubscriptionLicenceAdmin from "./SuperAmin/SubscriptionLicenceAdmin";
// Change #100462
import EnterprisePlans from "./SuperAmin/EnterprisePlans";
import LicenceEnforcement from "./SuperAmin/LicenceEnforcement";
import SubscriptionLicenceRenewal from "./SuperAmin/SubscriptionLicenceRenewal";
import SubscriptionLicenceRenewalAttempt from "./SuperAmin/SubscriptionLicenceRenewalAttempt";
import SubscriptionProductFeatures from "./SuperAmin/SubscriptionProductFeatures";
import SubscriptionProductToMasterSecurityAuthCapability from "./SuperAmin/SubscriptionProductToMasterSecurityAuthCapability";
import SubscriptionTransactionCharge from "./SuperAmin/SubscriptionTransactionCharge";
import SystemCodeBaseVersionCommit from "./SuperAmin/SystemCodeBaseVersionCommit";
import TestingUserLogin from "./SuperAmin/TestingUserLogin";
import UserActivityLog from "./SuperAmin/UserActivityLog";
import UserActivityLogType from "./SuperAmin/UserActivityLogType";
import UserCompanySubscriptionProductAssignment from "./SuperAmin/UserCompanySubscriptionProductAssignment";
import UserLoginLog from "./SuperAmin/UserLoginLog";
// ===== END Task 24429 master admin ===== imports

// Developer access (Task 24434) is pinned to one account, not a role or a
// capability - anyone who administers roles could otherwise hand out a flag
// that reaches every company on the platform. Keep in step with
// DeveloperAccessController::ALLOWED_USER_ID.
const ALLOWED_DEVELOPER_FLAG_USER_ID = 45;

/**
 * Evaluate a nav entry's `gate` against the CURRENT authUser (Task 24581).
 *
 * These three checks used to be module-level consts. A module-level const is
 * evaluated once, when this module is first imported - so if the SPA booted
 * before login and was never hard-reloaded, authUser was absent at that moment
 * and the const stayed false for the whole page session. That is how the
 * Database Deltas tab vanished for a user who demonstrably had the flag: the
 * section itself is gated by a read inside Settings/index.js, which re-runs on
 * every render, so the section appeared while its entries did not.
 *
 * Called from Settings/index.js during render, so it always sees the live
 * value. Entries without a `gate` are always visible.
 */
export const isSettingsEntryVisible = (entry) => {
  if (!entry?.gate) return true;

  const authUser = JSON.parse(localStorage.getItem("authUser") || "null");

  // Task 24780 - "flag developer =1 should have access to all options here".
  //
  // The developer flag is a master key over every settings gate, so a
  // developer sees the whole screen in any company they are in - including
  // ones where they hold no role 100, which is exactly the case that prompted
  // this (Task 24693 put a role-100 floor on four of the five sections).
  //
  // Done HERE rather than at each call site so there is one definition of it.
  // Settings/index.js reads its administrator100 answer from this function, so
  // the section tabs, the address-bar redirect and every gated rail entry all
  // follow from this one line and cannot disagree.
  //
  // `developerFlagOwner` is deliberately NOT included below: that gate controls
  // who may HAND OUT the developer flag, and is pinned to a single account on
  // purpose (Task 24434). A developer being able to grant the flag to someone
  // else would make the pin meaningless.
  const isDeveloper =
    Number(authUser?.get_user_data?.User_FlagDeveloper ?? 0) === 1;
  if (isDeveloper && entry.gate !== "developerFlagOwner") return true;

  switch (entry.gate) {
    case "developer":
      // Tolerant of "1" vs 1 - User.FlagDeveloper is a TINYINT, and a strict
      // string compare failed silently the moment the payload changed shape.
      return Number(authUser?.get_user_data?.User_FlagDeveloper ?? 0) === 1;

    case "developerFlagOwner":
      return (
        Number(authUser?.get_user_data?.User_Id ?? 0) ===
        ALLOWED_DEVELOPER_FLAG_USER_ID
      );

    case "administrator100":
      return Boolean(
        authUser?.get_securityauthrole_list?.find(
          (item) => Number(item?.SecurityAuthRole_Id) === 100
        )
      );

    default:
      // An unrecognised gate must not silently grant access.
      return false;
  }
};



export const settingsNavDataCompany = [
  // {
  //   id: 0,
  //   title: "Intro",
  //   icon: "fa-solid fa-info-circle",
  // },
  {
    id: 1,
    title: "Customer",
    icon: "fa-solid fa-building-user",
  },
  {
    id: 2,
    title: "Job",
    icon: "fa-solid fa-clipboard-list",
  },
  {
    id: 3,
    title: "Task",
    icon: "fa-solid fa-list-check",
  },
  {
    id: 45,
    title: "Task Checklist",
    icon: "fa-solid fa-clipboard-check",
  },
  {
    id: 4,
    title: "Invoicing",
    icon: "fa-solid fa-file-pdf",
  },
  {
    id: 5,
    title: "Opportunity",
    icon: "fa-solid fa-file-pdf",
  },
  {
    id: 6,
    title: "Quoting",
    icon: "fas fa-file-alt",
  },
  {
    id: 7,
    title: "Banking",
    icon: "fa-solid fa-building-columns",
  },
  {
    id: 8,
    title: "Purchases",
    icon: "fa-solid fa-credit-card",
  },
  {
    id: 9,
    title: "Time Entry",
    icon: "fa-regular fa-calendar-days",
  },
  {
    id: 10,
    title: "Debt Chasing",
    icon: "fa-solid fa-coins",
  },
  {
    id: 11,
    title: "Staff",
    icon: "fa-solid fa-people-group",
  },
  {
    id: 12,
    title: "Communications",
    icon: "fas fa-comments",
  },
  // Change #100326 - sits next to Communications. The panel gates itself on the
  // CRM_WHATSAPP module (ModuleGate), so no nav `gate` is needed.
  {
    id: 54,
    title: "WhatsApp",
    icon: "ri-whatsapp-line",
  },
  {
    id: 13,
    title: "Menus",
    icon: "fa-solid fa-bars",
  },
  // {
  //   id: 14,
  //   title: "Card List",
  //   icon: "fa-solid fa-credit-card",
  // },
  {
    id: 15,
    title: "General",
    icon: "fa-solid fa-sliders",
  },
  // Task 24581 - gate evaluated at render time, see the note on id 14 above.
  {
    id: 16,
    title: "User Invitation",
    icon: "fa-solid fa-user-plus",
    gate: "administrator100",
  },
  {
    id: 17,
    title: "Team Members",
    icon: "fa-solid fa-user-friends",
  },
  {
    id: 18,
    title: "Manage License",
    icon: "fa-regular fa-id-badge",
  },
  {
    id: 19,
    title: "Liability",
    icon: "fa-solid fa-book",
  },
  {
    id: 20,
    title: "Security",
    icon: "fa-solid fa-shield-halved",
  },
  {
    id: 21,
    title: "Company",
    icon: "fa-solid fa-building",
  },
  {
    id: 22,
    title: "Email",
    icon: "fa-solid fa-envelope",
  },
  {
    id: 23,
    title: "Appointments",
    icon: "fa-solid fa-calendar",
  },
  {
    id: 24,
    title: "Accounting Periods",
    icon: "fa-solid fa-calendar",
  },
  {
    id: 25,
    title: "Food Preorder",
    icon: "fa-solid fa-utensils",
  },
  {
    id: 26,
    title: "Vehicle",
    icon: "fa-solid fa-car",
  },
  {
    id: 27,
    title: "3rd Party Integration",
    icon: "fa-solid fa-circle-nodes",
  },
  {
    id: 28,
    title: "Proforma Invoicing",
    icon: "fa-solid fa-file-pdf",
  },
  {
    id: 29,
    title: "Staff Leave",
    icon: "fa-regular fa-calendar-check",
  },
  {
    id: 30,
    title: "Organisation Department",
    icon: "fa-solid fa-sitemap",
  },
  {
    id: 31,
    title: "Product",
    icon: "fa-solid fa-cubes",
  },
  {
    id: 32,
    title: "Sales Order",
    icon: "fa-solid fa-receipt",
  },
  {
    id: 33,
    title: "Purchase Order",
    icon: "fa-solid fa-shopping-cart",
  },
  {
    id: 34,
    title: "Social Media Management",
    icon: "fa-brands fa-facebook-messenger",
  },
  {
    id: 35,
    title: "Leads",
    icon: "fa-solid fa-user-plus",
  },
  {
    id: 36,
    title: "Calls",
    icon: "fa-solid fa-phone",
  },
  {
    id: 37,
    title: "Loyalty",
    icon: "fa-solid fa-star",
  },{
    id: 38,
    title: "System Device",
    icon: "fa-solid fa-desktop",
  },{
    id: 39,
    title: "SMS",
    icon: "fa-solid fa-mobile-screen-button",
  },{
    id: 40,
    title: "Asset",
    icon: "fa-solid fa-box-archive",
  },
  {
    id: 41,
    title: "Attachments",
    icon: "fa-solid fa-paperclip",
  },
  {
    id: 42,
    title: "Company Vehicle",
    icon: "fa-solid fa-truck",
  },
  {
    id: 43,
    title: "Config Items",
    icon: "fa-solid fa-gears",
  },
  {
    id: 44,
    title: "API Keys",
    icon: "fa-solid fa-key",
  },
  {
    id: 46,
    title: "POS Hardware",
    icon: "fa-solid fa-cash-register",
  },
  {
    id: 47,
    title: "Onboarding",
    icon: "fa-solid fa-list-check",
  },
  {
    id: 48,
    title: "E-Sign Reminders",
    icon: "fa-solid fa-bell",
  },
  {
    id: 49,
    title: "Customer Portal",
    icon: "fa-solid fa-user-lock",
  },
  // Task 24474 - the agreed response and delivery commitments.
  {
    id: 50,
    title: "SLAs",
    icon: "fa-solid fa-shield-halved",
  },
  // Task 24472 - our own premises, for shift start/end locations.
  {
    id: 51,
    title: "Site Locations",
    icon: "fa-solid fa-warehouse",
  },
  // Task 24711 - forms were only reachable from /form-list, which is not where
  // anyone looks for something they set up once and edit occasionally.
  {
    id: 52,
    title: "Forms",
    icon: "fa-solid fa-clipboard-list",
  },
  // Change #100094 - tokens for the /clock-in-out tablet were only obtainable by
  // logging in as a manager on the tablet itself.
  {
    id: 53,
    title: "Clock-In Kiosks",
    icon: "fa-solid fa-tablet-screen-button",
  },
  // Change #100666 - a company admin's read-only view of the SIMs we have
  // assigned to them, with live status from emnify. (54 is WhatsApp.)
  {
    id: 55,
    title: "SIM Connectivity",
    icon: "fa-solid fa-sim-card",
    gate: "administrator100",
  },
];

export const settingsContentDataCompany = [
  {
    id: 0,
    content: <CompanySettingsIntro />,
  },
  {
    id: 1,
    content: <CustomerSettings />,
  },
  {
    id: 2,
    content: <JobSettings />,
  },
  {
    id: 3,
    content: <TaskSettings />,
  },
  {
    id: 45,
    content: <TaskChecklistSettings />,
  },
  {
    id: 4,
    content: <InvoicingSettings />,
  },
  {
    id: 5,
    content: <OpportunitySettings />,
  },
  {
    id: 6,
    content: <QuotingSettings />,
  },
  {
    id: 7,
    content: <BankingSettings />,
  },
  {
    id: 8,
    content: <PurchasesSettings />,
  },
  {
    id: 9,
    content: <TimeEntrySettings />,
  },
  {
    id: 10,
    content: <DebtChasingSettings />,
  },
  {
    id: 11,
    content: <StaffSettings />,
  },
  {
    id: 12,
    content: <CommunicationsSettings />,
  },
  {
    id: 54,
    content: <WhatsAppSettings />,
  },
  {
    id: 13,
    content: <MenuSettings />,
  },
  {
    id: 14,
    content: <CardList />,
  },
  {
    id: 15,
    content: <GeneralSettings />,
  },
  {
    id: 16,
    content: <UserInvitation />,
  },
  {
    id: 17,
    content: <TeamMembers />,
  },
  {
    id: 18,
    content: <ManageLicense />,
  },
  {
    id: 19,
    content: <LiabilitySettings />,
  },
  {
    id: 20,
    content: <CompanySecuritySettings />,
  },
  {
    id: 21,
    content: <CompanySettings />,
  },
  {
    id: 22,
    content: <EmailSettings />,
  },
  {
    id: 23,
    content: <AppointmentSettings />,
  },
  {
    id: 24,
    content: <AccountingPeriods />,
  },
  {
    id: 25,
    content: <EventsSettings />,
  },
  {
    id: 26,
    content: <VehicleSettings />,
  },
  {
    id: 27,
    content: <ThirdPartyIntegrationSettings />,
  },
  {
    id: 28,
    content: <ProformaInvoicingSettings />,
  },
  {
    id: 29,
    content: <StaffLeaveSettingsPage />,
  },
  {
    id: 30,
    content: <OrganisationDepartmentSettings />,
  },
  {
    id: 31,
    content: <ProductSettings />,
  },
  {
    id: 32,
    content: <SalesOrderSettings />,
  },
  {
    id: 33,
    content: <PurchaseOrderSettings />,
  },
  {
    id: 34,
    content: <SocialMediaManagementSettings />,
  },
  {
    id: 35,
    content: <LeadsSettings />,
  },
  {
    id: 36,
    content: <CallsSettings />,
  },
  {
    id: 37,
    content: <LoyaltySettingsPage />,
  },
  {
    id: 38,
    content: <SystemDeviceSettings />,
  },
  {
    id: 39,
    content: <SMSSettings />,
  },
  {
    id: 40,
    content: <AssetSettings />,
  },
  {
    id: 41,
    content: <AttachmentSettings />,
  },
  {
    id: 42,
    content: <CompanyVehicleSettings />,
  },
  {
    id: 43,
    content: <ConfigItems />,
  },
  {
    id: 44,
    content: <ApiKeysSettings />,
  },
  {
    id: 46,
    content: <SystemDeviceHardwareSettings />,
  },
  {
    id: 47,
    content: <CompanyOnboarding />,
  },
  {
    id: 48,
    content: <ESignReminderSchedules />,
  },
  {
    id: 49,
    content: <PortalProfiles />,
  },
  {
    id: 50,
    content: <SlaSettings />,
  },
  {
    id: 51,
    content: <CompanySiteLocations />,
  },
  {
    id: 52,
    content: <FormsSettings />,
  },
  {
    id: 53,
    content: <ClockInKiosksSettings />,
  },
  {
    id: 55,
    content: <CompanySims />,
  },
];

export const settingsNavDataUserProfile = [
  // {
  //   id: 0,
  //   title: "Intro",
  //   icon: "fa-solid fa-info-circle",
  // },
  {
    id: 1,
    title: "General",
    icon: "fa-solid fa-sliders",
  },
  {
    id: 2,
    title: "My Invitations",
    icon: "fa-solid fa-user-plus",
  },
  {
    id: 3,
    title: "Debug",
    icon: "fa-solid fa-bug",
  },
  // {
  //   id: 4,
  //   title: "Billing",
  //   icon: "fa-solid fa-credit-card",
  // },
  {
    id: 5,
    title: "My Shortcuts",
    icon: "fa-solid fa-bars",
  },
  {
    id: 6,
    title: "Passwords",
    icon: "fa-solid fa-key",
  },
  {
    id: 7,
    title: "Clock-In PIN",
    icon: "fa-solid fa-hashtag",
  },
  {
    id: 8,
    title: "Recently Viewed",
    icon: "fa-solid fa-clock-rotate-left",
  },
  {
    id: 9,
    title: "My Devices",
    icon: "fa-solid fa-laptop",
  },

];

export const settingsContentDataUserProfile = [
  {
    id: 0,
    content: <ProfileSettingsIntro />,
  },
  {
    id: 1,
    content: <UserProfileGeneralSettings />,
  },
  {
    id: 2,
    content: <CompanyInvitations />,
  },
  {
    id: 3,
    content: <Debug />,
  },
  {
    id: 4,
    content: <Billing />,
  },
  {
    id: 5,
    content: <MyShortcutSettings />,
  },
  {
    id: 6,
    content: <ManageUserPassword />,
  },
  {
    id: 7,
    content: <ClockInPinSettings />,
  },
  {
    id: 8,
    content: <RecentlyViewedSettings />,
  },
  {
    id: 9,
    content: <MyDevicesSettings />,
  },

];

// Super Admin
export const settingsNavDataSuperAdmin = [
  {
    id: 1,
    title: "General",
    icon: "fa-solid fa-sliders",
  },
  {
    id: 2,
    title: "Scribe Settings",
    icon: "fa-solid fa-circle-info",
  },
  {
    id: 3,
    title: "Master Payment Provider",
    icon: "fa-solid fa-money-check",
  },
  {
    id: 4,
    title: "Notification Center",
    icon: "fa-solid fa-bell",
  },
  {
    id: 5,
    title: "Cron Schedules",
    icon: "fa-solid fa-clock-rotate-left",
  },
  {
    id: 6,
    title: "Super Menu",
    icon: "fa-solid fa-bars",
  },
  {
    // Task 24886 - the menu builder at master level. Sits next to Super Menu
    // because that screen maintains the DESTINATIONS these menus point at.
    // Developer-gated: a rollout writes to every company database.
    id: 17,
    title: "Global Menus",
    icon: "fa-solid fa-earth-europe",
    gate: "developer",
  },
  {
    id: 7,
    title: "Master",
    icon: "fa-solid fa-crown",
  },
  {
    id: 8,
    title: "System Servers",
    icon: "fa-solid fa-server",
  },
  {
    id: 9,
    title: "Third-Party Pricing",
    icon: "fa-solid fa-money-bill-trend-up",
  },
  {
    id: 10,
    title: "SIM Management",
    icon: "fa-solid fa-sim-card",
  },
  {
    id: 11,
    title: "Config Items",
    icon: "fa-solid fa-sliders",
  },
  {
    id: 12,
    title: "Devices",
    icon: "fa-solid fa-laptop",
  },
  {
    id: 13,
    title: "Master External Id Providers",
    icon: "fa-solid fa-id-card",
  },
  {
    // Task 24428 - which users belong to which companies, platform-wide.
    id: 15,
    title: "User / Company Mapping",
    icon: "fa-solid fa-users-between-lines",
  },
  // Running arbitrary SQL against every company database is a developer tool,
  // not a super-admin one, so the entry only appears for User.FlagDeveloper.
  //
  // Task 24581: this used to be a conditional spread evaluated against a
  // module-level const. That const is read ONCE when this module is first
  // imported, so if authUser was not yet in localStorage at that moment the
  // entry was dropped for the whole page session - which is exactly how this
  // tab "disappeared". The entry is now always present and carries a `gate`
  // that Settings/index.js evaluates at RENDER time.
  {
    id: 14,
    title: "Database Deltas",
    icon: "fa-solid fa-database",
    gate: "developer",
  },
  // Task 24900 - every 5xx across every company, with request/response/trace.
  // Cross-company data, so developer-gated like Database Deltas.
  {
    id: 18,
    title: "Server Errors",
    icon: "fa-solid fa-bug",
    gate: "developer",
  },
  // Change #100539 - every refused request (401/402/403 and the 49x licence
  // codes) across every company. Developer-gated like Server Errors.
  {
    id: 20,
    title: "Auth Failures",
    icon: "fa-solid fa-user-shield",
    gate: "developer",
  },
  // Task 24912 - every bug and improvement to CRMit, moved out of company 3
  // tasks into ZCRM_Master, with bundles (releases). Developer-gated like the two above.
  {
    id: 19,
    title: "System Changes",
    icon: "fa-solid fa-code-branch",
    gate: "developer",
  },

  // Task 24434 - who holds User.FlagDeveloper. Sits in the Users & Access
  // folder, and only the nominated account ever sees the entry.
  {
    id: 16,
    title: "Developers",
    icon: "fa-solid fa-user-lock",
    group: "Users & Access",
    gate: "developerFlagOwner",
  },

// ===== BEGIN Task 24429 master admin (generated by ztools/masteradmin) ===== nav
  { id: 100, title: "Access Block Reason", icon: "fa-solid fa-table", group: "Platform & Companies" },
  { id: 101, title: "Api Key To Auth Capability", icon: "fa-solid fa-table", group: "API Keys & Tokens" },
  { id: 102, title: "Attachment Provider", icon: "fa-solid fa-table", group: "Reference Data" },
  { id: 103, title: "Bank Account Provider", icon: "fa-solid fa-table", group: "Reference Data" },
  { id: 104, title: "Call Recording", icon: "fa-solid fa-table", group: "Platform & Companies" },
  { id: 105, title: "SIC Code Group", icon: "fa-solid fa-table", group: "Prospecting" },
  { id: 106, title: "SIC Code Group Value", icon: "fa-solid fa-table", group: "Prospecting" },
  { id: 107, title: "Company Status", icon: "fa-solid fa-table", group: "Platform & Companies" },
  { id: 108, title: "Company To User Invitation", icon: "fa-solid fa-table", group: "Users & Access" },
  { id: 109, title: "Company To User Invitation Status", icon: "fa-solid fa-table", group: "Users & Access" },
  { id: 110, title: "Company To User Request", icon: "fa-solid fa-table", group: "Users & Access" },
  { id: 111, title: "Company Usage Stats", icon: "fa-solid fa-table", group: "Platform & Companies" },
  { id: 112, title: "Company Usage Stats History", icon: "fa-solid fa-table", group: "Platform & Companies" },
  { id: 113, title: "Cron Interval", icon: "fa-solid fa-table", group: "Cron & Scheduling" },
  { id: 114, title: "Dashboard Box", icon: "fa-solid fa-table", group: "Reporting & Dashboards" },
  { id: 115, title: "Documentation Guide", icon: "fa-solid fa-table", group: "Platform & Companies" },
  { id: 116, title: "Global Api Log", icon: "fa-solid fa-table", group: "API Keys & Tokens" },
  { id: 117, title: "Global Ecommerce Store", icon: "fa-solid fa-table", group: "Global Widgets" },
  { id: 118, title: "Global Email Account", icon: "fa-solid fa-table", group: "Email & Communications" },
  { id: 119, title: "Global Email Outbound", icon: "fa-solid fa-table", group: "Email & Communications" },
  { id: 120, title: "Global External Id Mapping", icon: "fa-solid fa-table", group: "Global Widgets" },
  { id: 121, title: "Global Food Table Widget", icon: "fa-solid fa-table", group: "Global Widgets" },
  { id: 122, title: "Global Loyalty Portal", icon: "fa-solid fa-table", group: "Global Widgets" },
  { id: 123, title: "Global Self-Serve Widget", icon: "fa-solid fa-table", group: "Global Widgets" },
  { id: 124, title: "Bank Account Feed Provider", icon: "fa-solid fa-table", group: "Banking" },
  { id: 125, title: "Bank Account Feed Status", icon: "fa-solid fa-table", group: "Banking" },
  { id: 126, title: "Bank Account Provider", icon: "fa-solid fa-table", group: "Banking" },
  { id: 127, title: "Bank Third-Party Data Provider", icon: "fa-solid fa-table", group: "Banking" },
  { id: 128, title: "Config Item Field Type", icon: "fa-solid fa-table", group: "Reference Data" },
  { id: 129, title: "Dashboard Template", icon: "fa-solid fa-table", group: "Reporting & Dashboards" },
  { id: 130, title: "Database Template", icon: "fa-solid fa-table", group: "Platform & Companies" },
  { id: 131, title: "Database Utilisation Alert", icon: "fa-solid fa-table", group: "Database Operations" },
  { id: 132, title: "Email Account Inbound", icon: "fa-solid fa-table", group: "Email & Communications" },
  { id: 133, title: "Email Outbound", icon: "fa-solid fa-table", group: "Email & Communications" },
  { id: 134, title: "Email Template", icon: "fa-solid fa-table", group: "Email & Communications" },
  { id: 135, title: "Email Template System Type", icon: "fa-solid fa-table", group: "Email & Communications" },
  { id: 136, title: "Hardware Catalog Type", icon: "fa-solid fa-table", group: "Hardware & Connectivity" },
  { id: 137, title: "Hardware Item", icon: "fa-solid fa-table", group: "Hardware & Connectivity" },
  { id: 138, title: "Hardware Item Connectivity", icon: "fa-solid fa-table", group: "Hardware & Connectivity" },
  { id: 139, title: "HMRC Employment Allowance", icon: "fa-solid fa-table", group: "Reference Data" },
  { id: 140, title: "Meeting Bot Index", icon: "fa-solid fa-table", group: "Reference Data" },
  { id: 141, title: "NFC Tag", icon: "fa-solid fa-table", group: "Hardware & Connectivity" },
  { id: 142, title: "Object Type", icon: "fa-solid fa-table", group: "Platform & Companies" },
  { id: 143, title: "Pdf Theme Output", icon: "fa-solid fa-table", group: "Reference Data" },
  { id: 144, title: "Post Code Lookup", icon: "fa-solid fa-table", group: "Reference Data" },
  { id: 145, title: "Prospect Company", icon: "fa-solid fa-table", group: "Prospecting" },
  { id: 146, title: "Prospect Company Sic Code", icon: "fa-solid fa-table", group: "Prospecting" },
  { id: 147, title: "Referral Partner", icon: "fa-solid fa-table", group: "Referrals & Commission" },
  { id: 148, title: "Referral Partner Commission", icon: "fa-solid fa-table", group: "Referrals & Commission" },
  { id: 149, title: "Reporting Group", icon: "fa-solid fa-table", group: "Reporting & Dashboards" },
  { id: 150, title: "Reporting Item", icon: "fa-solid fa-table", group: "Reporting & Dashboards" },
  { id: 151, title: "Security Auth Capability", icon: "fa-solid fa-table", group: "Security & Access" },
  { id: 152, title: "Capability Front-End Location", icon: "fa-solid fa-table", group: "Security & Access" },
  { id: 153, title: "Capability To Portal", icon: "fa-solid fa-table", group: "Security & Access" },
  { id: 154, title: "Security Auth Group", icon: "fa-solid fa-table", group: "Security & Access" },
  { id: 155, title: "Security Auth Role", icon: "fa-solid fa-table", group: "Security & Access" },
  { id: 156, title: "Sim Assignment", icon: "fa-solid fa-table", group: "Hardware & Connectivity" },
  { id: 157, title: "Slow Query Snapshot", icon: "fa-solid fa-table", group: "Database Operations" },
  { id: 158, title: "Slow Query Top Offender", icon: "fa-solid fa-table", group: "Database Operations" },
  { id: 159, title: "Special Day", icon: "fa-solid fa-table", group: "Cron & Scheduling" },
  { id: 160, title: "Master Staff", icon: "fa-solid fa-table", group: "Platform & Companies" },
  { id: 161, title: "Subscription", icon: "fa-solid fa-table", group: "Subscriptions & Billing" },
  { id: 162, title: "System Debug Log", icon: "fa-solid fa-table", group: "Database Operations" },
  { id: 163, title: "System Email Template", icon: "fa-solid fa-table", group: "Email & Communications" },
  { id: 164, title: "System Error Log", icon: "fa-solid fa-table", group: "Database Operations" },
  { id: 165, title: "System Field", icon: "fa-solid fa-table", group: "Platform & Companies" },
  { id: 166, title: "System Module", icon: "fa-solid fa-table", group: "Platform & Companies" },
  { id: 167, title: "System Wallet Service Rate", icon: "fa-solid fa-table", group: "System Wallet" },
  { id: 168, title: "System Wallet Status", icon: "fa-solid fa-table", group: "System Wallet" },
  { id: 169, title: "System Wallet Top Up Attempt", icon: "fa-solid fa-table", group: "System Wallet" },
  { id: 170, title: "Third-Party Pricing Bracket", icon: "fa-solid fa-table", group: "Reference Data" },
  { id: 171, title: "Third-Party Pricing Service", icon: "fa-solid fa-table", group: "Reference Data" },
  { id: 172, title: "Time Frame Interval", icon: "fa-solid fa-table", group: "Cron & Scheduling" },
  { id: 173, title: "Token Key", icon: "fa-solid fa-table", group: "API Keys & Tokens" },
  { id: 174, title: "Token Key Access", icon: "fa-solid fa-table", group: "API Keys & Tokens" },
  { id: 175, title: "Token Key Type", icon: "fa-solid fa-table", group: "API Keys & Tokens" },
  { id: 176, title: "User To Auth Permission", icon: "fa-solid fa-table", group: "Security & Access" },
  { id: 177, title: "WiFi Portal Site", icon: "fa-solid fa-table", group: "Hardware & Connectivity" },
  { id: 178, title: "Permission Option", icon: "fa-solid fa-table", group: "Security & Access" },
  { id: 179, title: "Referral Income", icon: "fa-solid fa-table", group: "Referrals & Commission" },
  { id: 180, title: "Referral Income Item", icon: "fa-solid fa-table", group: "Referrals & Commission" },
  { id: 181, title: "Referral Payout", icon: "fa-solid fa-table", group: "Referrals & Commission" },
  { id: 182, title: "Referral Recognition Item", icon: "fa-solid fa-table", group: "Referrals & Commission" },
  { id: 183, title: "Referral Reward", icon: "fa-solid fa-table", group: "Referrals & Commission" },
  { id: 184, title: "Subscription Cancellation Reason", icon: "fa-solid fa-table", group: "Subscriptions & Billing" },
  { id: 196, title: "Subscription Licences", icon: "fa-solid fa-id-card", group: "Subscriptions & Billing" },
  // Change #100462
  { id: 197, title: "Enterprise Plans", icon: "fa-solid fa-building-shield", group: "Subscriptions & Billing" },
  { id: 198, title: "Licence Enforcement", icon: "fa-solid fa-user-lock", group: "Subscriptions & Billing" },
  { id: 185, title: "Subscription Licence Renewal", icon: "fa-solid fa-table", group: "Subscriptions & Billing" },
  { id: 186, title: "Subscription Licence Renewal Attempt", icon: "fa-solid fa-table", group: "Subscriptions & Billing" },
  { id: 187, title: "Subscription Product Features", icon: "fa-solid fa-table", group: "Subscriptions & Billing" },
  { id: 188, title: "Product To Capability", icon: "fa-solid fa-table", group: "Subscriptions & Billing" },
  { id: 189, title: "Subscription Transaction Charge", icon: "fa-solid fa-table", group: "Subscriptions & Billing" },
  { id: 190, title: "System Code Base Version Commit", icon: "fa-solid fa-table", group: "Platform & Companies" },
  { id: 191, title: "Testing User Login", icon: "fa-solid fa-table", group: "Users & Access" },
  { id: 192, title: "User Activity Log", icon: "fa-solid fa-table", group: "Users & Access" },
  { id: 193, title: "User Activity Log Type", icon: "fa-solid fa-table", group: "Users & Access" },
  { id: 194, title: "User Company Product Assignment", icon: "fa-solid fa-table", group: "Subscriptions & Billing" },
  { id: 195, title: "User Login Log", icon: "fa-solid fa-table", group: "Users & Access" },
// ===== END Task 24429 master admin ===== nav

];

export const settingsContentDataSuperAdmin = [
  {
    id: 0,
    content: <SuperAdminSettingsIntro />,
  },
  {
    id: 1,
    content: <SuperGeneralSettings />,
  },
  {
    id: 2,
    content: <SuperScribeSettings />,
  },
  {
    id: 3,
    content: <MasterPaymentProvider />,
  },
  {
    id: 4,
    content: <NotificationCenter />,
  },
  { id: 5, content: <CronSchedules /> },
  {
    id: 6,
    content: <SuperMenuSettings />,
  },
  {
    id: 17,
    content: <GlobalMenuSettings />,
  },
  {
    id: 7,
    content: <Master />,
  },
  {
    id: 8,
    content: <SystemServers />,
  },
  {
    id: 9,
    content: <MasterThirdPartyPricing />,
  },
  {
    id: 10,
    content: <MasterSim />,
  },
  {
    id: 11,
    content: <MasterConfigItem />,
  },
  {
    id: 12,
    content: <SuperAdminDevices />,
  },
  {
    id: 13,
    content: <MasterExternalIdentificationProvider />,
  },
  {
    id: 14,
    content: <DatabaseDelta />,
  },
  // Task 24900
  {
    id: 18,
    content: <ServerErrorLog />,
  },
  // Change #100539
  {
    id: 20,
    content: <AuthFailureLog />,
  },
  // Task 24912
  {
    id: 19,
    content: <SystemChanges />,
  },
  // Task 24428 - platform-wide user-to-company mapping
  {
    id: 15,
    content: <UserCompanyMapping />,
  },
  {
    // Task 24434 - the Developers panel. It renders a notice rather than the
    // grids for anyone but the nominated account, and the backend refuses
    // them as well.
    id: 16,
    content: <Developers />,
  },

// ===== BEGIN Task 24429 master admin (generated by ztools/masteradmin) ===== content
  { id: 100, content: <AccessBlockReason /> },
  { id: 101, content: <ApiKeyToAuthCapability /> },
  { id: 102, content: <AttachmentProvider /> },
  { id: 103, content: <BankAccountProvider /> },
  { id: 104, content: <CallRecording /> },
  { id: 105, content: <CompaniesHouseSicCodeGroup /> },
  { id: 106, content: <CompaniesHouseSicCodeGroupValue /> },
  { id: 107, content: <CompanyStatus /> },
  { id: 108, content: <CompanyToUserInvitation /> },
  { id: 109, content: <CompanyToUserInvitationStatus /> },
  { id: 110, content: <CompanyToUserRequest /> },
  { id: 111, content: <CompanyUsageStats /> },
  { id: 112, content: <CompanyUsageStatsHistory /> },
  { id: 113, content: <CronInterval /> },
  { id: 114, content: <DashboardBox /> },
  { id: 115, content: <DocumentationGuide /> },
  { id: 116, content: <GlobalApiLog /> },
  { id: 117, content: <GlobalEcommerceStore /> },
  { id: 118, content: <GlobalEmailAccount /> },
  { id: 119, content: <GlobalEmailOutbound /> },
  { id: 120, content: <GlobalExternalIdMapping /> },
  { id: 121, content: <GlobalFoodTableWidget /> },
  { id: 122, content: <GlobalLoyaltyPortal /> },
  { id: 123, content: <GlobalProductSelfServeWidget /> },
  { id: 124, content: <MasterBankAccountFeedProvider /> },
  { id: 125, content: <MasterBankAccountFeedStatus /> },
  { id: 126, content: <MasterBankAccountProvider /> },
  { id: 127, content: <MasterBankAccountThirdPartyDataProvider /> },
  { id: 128, content: <MasterConfigItemFieldType /> },
  { id: 129, content: <MasterDashboardTemplate /> },
  { id: 130, content: <MasterDatabaseTemplate /> },
  { id: 131, content: <MasterDatabaseUtilisationAlert /> },
  { id: 132, content: <MasterEmailAccountInbound /> },
  { id: 133, content: <MasterEmailOutbound /> },
  { id: 134, content: <MasterEmailTemplate /> },
  { id: 135, content: <MasterEmailTemplateSystemType /> },
  { id: 136, content: <MasterHardwareCatalogType /> },
  { id: 137, content: <MasterHardwareItem /> },
  { id: 138, content: <MasterHardwareItemConnectivity /> },
  { id: 139, content: <MasterHmrcEmploymentAllowance /> },
  { id: 140, content: <MasterMeetingBotIndex /> },
  { id: 141, content: <MasterNfcTag /> },
  { id: 142, content: <MasterObjectType /> },
  { id: 143, content: <MasterPdfThemeOutput /> },
  { id: 144, content: <MasterPostCodeLookup /> },
  { id: 145, content: <MasterProspectCompany /> },
  { id: 146, content: <MasterProspectCompanySicCode /> },
  { id: 147, content: <MasterReferralPartner /> },
  { id: 148, content: <MasterReferralPartnerCommission /> },
  { id: 149, content: <MasterReportingGroup /> },
  { id: 150, content: <MasterReportingItem /> },
  { id: 151, content: <MasterSecurityAuthCapability /> },
  { id: 152, content: <MasterSecurityAuthCapabilityFrontEndLocations /> },
  { id: 153, content: <MasterSecurityAuthCapabilityToPortal /> },
  { id: 154, content: <MasterSecurityAuthGroup /> },
  { id: 155, content: <MasterSecurityAuthRole /> },
  { id: 156, content: <MasterSimAssignment /> },
  { id: 157, content: <MasterSlowQuerySnapshot /> },
  { id: 158, content: <MasterSlowQueryTopOffender /> },
  { id: 159, content: <MasterSpecialDay /> },
  { id: 160, content: <MasterStaff /> },
  { id: 161, content: <MasterSubscription /> },
  { id: 162, content: <MasterSystemDebugLog /> },
  { id: 163, content: <MasterSystemEmailTemplate /> },
  { id: 164, content: <MasterSystemErrorLog /> },
  { id: 165, content: <MasterSystemField /> },
  { id: 166, content: <MasterSystemModule /> },
  { id: 167, content: <MasterSystemWalletServiceRate /> },
  { id: 168, content: <MasterSystemWalletStatus /> },
  { id: 169, content: <MasterSystemWalletTopUpAttempt /> },
  { id: 170, content: <MasterThirdPartyPricingBracket /> },
  { id: 171, content: <MasterThirdPartyPricingService /> },
  { id: 172, content: <MasterTimeFrameInterval /> },
  { id: 173, content: <MasterTokenKey /> },
  { id: 174, content: <MasterTokenKeyAccess /> },
  { id: 175, content: <MasterTokenKeyType /> },
  { id: 176, content: <MasterUserToSecurityAuthPermission /> },
  { id: 177, content: <MasterWifiPortalSite /> },
  { id: 178, content: <PermissionOption /> },
  { id: 179, content: <ReferralIncome /> },
  { id: 180, content: <ReferralIncomeItem /> },
  { id: 181, content: <ReferralPayout /> },
  { id: 182, content: <ReferralRecognitionItem /> },
  { id: 183, content: <ReferralReward /> },
  { id: 184, content: <SubscriptionCancellationReason /> },
  { id: 196, content: <SubscriptionLicenceAdmin /> },
  { id: 197, content: <EnterprisePlans /> },
  { id: 198, content: <LicenceEnforcement /> },
  { id: 185, content: <SubscriptionLicenceRenewal /> },
  { id: 186, content: <SubscriptionLicenceRenewalAttempt /> },
  { id: 187, content: <SubscriptionProductFeatures /> },
  { id: 188, content: <SubscriptionProductToMasterSecurityAuthCapability /> },
  { id: 189, content: <SubscriptionTransactionCharge /> },
  { id: 190, content: <SystemCodeBaseVersionCommit /> },
  { id: 191, content: <TestingUserLogin /> },
  { id: 192, content: <UserActivityLog /> },
  { id: 193, content: <UserActivityLogType /> },
  { id: 194, content: <UserCompanySubscriptionProductAssignment /> },
  { id: 195, content: <UserLoginLog /> },
// ===== END Task 24429 master admin ===== content

];

export const settingsNavDataBilling = [
  {
    id: 1,
    title: "Invoices",
    icon: "fa-solid fa-file-pdf",
  },
  {
    id: 2,
    title: "Manage License",
    icon: "fa-regular fa-id-badge",
  },
  // Change #100463 - plan, every licence paid for and who has it, bolt-ons.
  {
    id: 9,
    title: "Subscriptions",
    icon: "fa-solid fa-key",
  },
  {
    id: 3,
    title: "Card List",
    icon: "fa-solid fa-credit-card",
  },
  {
    id: 7,
    title: "Wallet",
    icon: "fa-solid fa-wallet",
  },
  // Task 24581 - gates evaluated at render time, see the note on id 14 above.
  {
    id: 8,
    title: "Invoice Recipients",
    icon: "fa-solid fa-envelope-open-text",
    gate: "administrator100",
  },
  {
    id: 4,
    title: "User Invitation",
    icon: "fa-solid fa-user-plus",
    gate: "administrator100",
  },
  {
    id: 5,
    title: "User Roles",
    icon: "fa-solid fa-user-shield",
    gate: "administrator100",
  },
  {
    id: 6,
    title: "Users",
    icon: "fa-solid fa-users",
    gate: "administrator100",
  },
];

export const settingsContentDataBilling = [
  {
    id: 0,
    content: <BillingSettingsIntro />,
  },
  {
    id: 1,
    content: <BillingOverview />,
  },
  {
    id: 2,
    content: <ManageLicense />,
  },
  {
    id: 9,
    content: <Subscriptions />,
  },
  {
    id: 3,
    content: <CardList />,
  },
  {
    id: 7,
    content: <WalletBilling />,
  },
  {
    id: 8,
    content: <InvoiceRecipients />,
  },
  {
    id: 4,
    content: <UserInvitation />,
  },
  {
    id: 5,
    content: <UserRoles />,
  },
  {
    id: 6,
    content: <Users />,
  },
];

export const settingsNavDataModules = [
  {
    id: 0,
    title: "Intro",
    icon: "fa-solid fa-info-circle",
  },
  {
    id: 1,
    title: "All Modules",
    icon: "fa-solid fa-cubes-stacked",
  },
];
export const settingsContentDataModules = [
  {
    id: 0,
    content: <ModulesSettingsIntro />,
  },
  {
    id: 1,
    content: <AllModulesSettings />,
  },
];